import {Component, Inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators} from '@angular/forms';
import {Survey} from '@app/api/models/survey';
import {User} from '@app/api/models/user';
import {PreferenceService} from '@app/api/services/preference.service';

import {PREFERENCE_PRIORITIES} from '@app/api/constants';
import {DIALOG_DATA, DialogRef} from "@angular/cdk/dialog";
import {ExclusionPreference, ExclusionPreferenceRequest} from "../../../../api/models/preference";
import {WaButtonDirective, WaDateInputDirective, WaDialogDirective, WaInputDirective} from "angular-awesome";

@Component({
  selector: 'app-exclusion-preference-dialog',
  templateUrl: './exclusion-preference-dialog.component.html',
  styleUrls: ['./exclusion-preference-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FormsModule, ReactiveFormsModule, WaButtonDirective, WaDialogDirective, WaInputDirective, WaDateInputDirective]
})
export class ExclusionPreferenceDialogComponent implements OnInit {

  user: User | null = null;
  survey: Survey | null = null;
  processing: boolean = false;

  exclusionForm = new FormGroup({
    note: new FormControl<string | null>(null),
    begin: new FormControl<Date | null>(null, Validators.required),
    end: new FormControl<Date | null>(null, Validators.required)
  });

  constructor(private prefService: PreferenceService,
              private dialogRef: DialogRef<ExclusionPreferenceRequest>,
              @Inject(DIALOG_DATA) data: {
                user: User | null,
                survey: Survey | null,
              },
              @Inject(PREFERENCE_PRIORITIES) public priorities: number[]) {

    if (!data) return;
    const user = data.user;
    const survey = data.survey;

    if (user)
      this.user = user;

    if (survey)
      this.survey = survey;
  }

  ngOnInit(): void {
  }

  private resetForm(form: UntypedFormGroup): void {
    form.reset();
    form.markAsPristine();
    form.markAsUntouched();
    form.clearValidators();
  }

  // Converts the local time zone to UTC
  private dateToUTC(originalDate: Date): Date {
    const inputDate = new Date(originalDate);
    const convertedDate = new Date(Date.UTC(inputDate.getFullYear(),
      inputDate.getMonth(),
      inputDate.getDate()));

    return convertedDate;
  }

  create(): void {
    if (!this.user || !this.survey)
      return;

    if (!this.isValidExclPref())
      return;

    const newExclPref = {
      user_id: this.user.id,
      survey_id: this.survey.id,
      note: this.note,
      begin: this.dateToUTC(this.begin!),
      end: this.dateToUTC(this.end!)
    };

    this.dialogRef.close(newExclPref);

    // console.log('This.begin', this.begin!);
    // console.log('This.end', this.end!);
    // console.log('newExclPref.begin', newExclPref.begin!);
    // console.log('newExclPref.end', newExclPref.end!);
    // console.log(newExclPref);

    //   this.setProcessing(true);
    //   this.prefService.createExclusionPreference(newExclPref).subscribe({
    //     next: pref => {
    //       this.setProcessing(false);
    //       this.dialogRef.close(pref);
    //     },
    //     error: err => {
    //       const msg = 'Could not create exclusion preference.';
    //       this.msgService.log(err.message);
    //       this.msgService.showSimple(msg).subscribe(() => {
    //         this.setProcessing(false);
    //       });
    //     }
    //   });

  }

  cancel(): void {
    this.dialogRef.close();
  }

  isCreateDisabled(): boolean {
    return !this.user || !this.survey || (!this.isValidPreference());
  }

  private isValidPreference(): boolean {
    return this.isValidExclPref();
  }

  private isValidExclPref(): boolean {
    return this.exclusionForm.valid;
  }

  private setProcessing(processing: boolean): void {
    this.processing = processing;
  }

  get note() {
    return this.exclusionForm.value.note || null
  }

  get begin() {
    return this.exclusionForm.value.begin || null
  }

  get end() {
    return this.exclusionForm.value.end || null
  }
}
